module.exports = __webpack_public_path__ + "img/logo-vb.b7c0292a.png";